import { useState, ComponentClass, FunctionComponent } from 'react';
import { NO_ELEMENT } from 'utils';
import { FacetFilter } from 'models/FacetFilter';
import { FilterDisplayType } from 'models/FilterDisplayType';
import { SimpleSliderFilter } from 'components/Filter/themes/BGH-RD3/types/simpleSlider';
import { CheckboxFilter } from './checkbox';
import { FilterGroup } from './group';
import { NoHeaderFilter } from './noHeader';

export interface FilterProps extends FacetFilter {
  isOpen: boolean;
  toggleOpen: () => void;
  webCatalog: string;
  noHeader?: boolean;
}

interface FilterTypes {
  [key: number]: ComponentClass<FilterProps> | FunctionComponent<FilterProps>;
}
const filterTypes = {
  [FilterDisplayType.Standard]: CheckboxFilter,
  [FilterDisplayType.Category]: CheckboxFilter,
  [FilterDisplayType.SimpleSlider]: SimpleSliderFilter,
  [FilterDisplayType.Group]: FilterGroup,
  [FilterDisplayType.NoHeader]: NoHeaderFilter
} as unknown as FilterTypes;

interface OwnProps {
  filter: FacetFilter;
  webCatalog: string;
  noHeader?: boolean;
  forceOpen?: boolean;
}
export const Filter = ({ filter, webCatalog, noHeader = false, forceOpen = false }: OwnProps) => {
  const [isOpen, setOpen] = useState(false);
  const toggleOpen = () => setOpen(!isOpen);

  const FilterComponent = filterTypes[filter.type];

  if (!FilterComponent) {
    return NO_ELEMENT;
  }

  return (
    <FilterComponent
      {...{
        ...filter,
        isOpen: forceOpen || isOpen,
        toggleOpen,
        webCatalog,
        noHeader
      }}
    />
  );
};
